import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202509: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202509",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-09-01",
  endDate: "2025-09-30",
  impressions: 84429,
  clicks: 1903,
  adsSpendDollars: 4445,
  budgetDollars: 4900,
  salesDollars: 12402,
  bestEstimateRoas: 2.79,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.91,
  newCustomersAcquired: 30,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-10-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
